import { z } from 'zod/v4'

export const documentValidation = () => {
  return z.object({
    new_document_ktp: z.string().optional().or(z.literal('')).nullable(),
    recent_document_ktp: z.string().optional().or(z.literal('')).nullable(),
    new_document_selfie_ktp: z.string().optional().or(z.literal('')).nullable(),
    recent_document_selfie_ktp: z.string().optional().or(z.literal('')).nullable(),
    verified_status: z.string().min(1, { message: 'Form is required' }),
  }).refine(
    (data) => {
      if (data.new_document_ktp !== null) {
        return data.new_document_selfie_ktp !== null
      }
      return true
    }, {
      message: 'if you upload new document ktp, you must upload new document selfie ktp',
      path: ['new_document_selfie_ktp'],
    }
  ).refine(
    (data) => {
      if (data.new_document_selfie_ktp !== null) {
        return data.new_document_ktp !== null
      }
      return true
    }, {
      message: 'if you upload document selfie ktp, you must upload new document ktp',
      path: ['new_document_ktp'],
    }
  )
}